import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "filexls"
const FilexlsIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M18.239 15.12C18.716 15.12 19.135 15.186 19.493 15.302Q19.584 15.331 19.67 15.364C20.497 15.692 20.958 16.334 21 17.177L21.005 17.277H19.38L19.377 17.225C19.338 16.892 19.087 16.652 18.708 16.548Q18.6 16.518 18.48 16.504 18.37 16.492 18.253 16.491C17.82 16.491 17.513 16.624 17.36 16.831L17.345 16.856Q17.293 16.932 17.27 17.02 17.249 17.096 17.248 17.177V17.182Q17.248 17.287 17.283 17.373 17.34 17.517 17.503 17.621 17.566 17.663 17.65 17.701 17.896 17.81 18.31 17.886L19.015 18.02Q19.766 18.163 20.245 18.43 20.375 18.5 20.487 18.583 20.637 18.694 20.751 18.823C21.018 19.126 21.148 19.51 21.148 19.991V19.996Q21.148 20.06 21.144 20.123 21.118 20.6 20.919 20.985C20.514 21.771 19.582 22.238 18.253 22.238 16.793 22.238 15.793 21.686 15.483 20.706Q15.456 20.616 15.436 20.522 15.418 20.442 15.406 20.36 15.394 20.266 15.387 20.167L15.382 20.081H17.006L17.016 20.135C17.1 20.576 17.615 20.867 18.285 20.867 18.981 20.867 19.41 20.57 19.41 20.143V20.138C19.41 19.998 19.37 19.885 19.282 19.79Q19.232 19.735 19.157 19.687C19.024 19.602 18.835 19.532 18.579 19.47Q18.451 19.44 18.301 19.41L17.596 19.277Q17.393 19.238 17.21 19.187C16.292 18.937 15.735 18.458 15.57 17.763Q15.538 17.634 15.525 17.493L15.515 17.302V17.296Q15.515 17.235 15.52 17.173C15.55 16.607 15.797 16.134 16.198 15.785 16.398 15.611 16.638 15.467 16.908 15.36Q17.025 15.312 17.148 15.275C17.478 15.175 17.844 15.12 18.238 15.12M11.867 15.245V20.71H14.709V22.114H10.119V15.244zM4.804 15.245 6.066 17.572H6.118L7.37 15.245H9.307L7.123 18.653V18.677L9.288 22.114H7.328L5.989 19.886H5.946L4.618 22.114H2.762L4.862 18.662V18.634L2.768 15.244z" />
          <path
            fillRule="evenodd"
            d="M21 8.25V14.377C20.552 14.07 20.043 13.867 19.5 13.75V9H15.75C14.507 9 13.5 7.993 13.5 6.75V3H4.5V13.745H3V3C3 2.223 3.59 1.585 4.347 1.508L4.5 1.5H14.25zM15 6.75C15 7.164 15.335 7.5 15.75 7.5H18.129L14.999 4.371z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default FilexlsIcon
